import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  LoadingController,
  Platform,
  AlertController,
} from "ionic-angular";
import { ApplicationApiProvider } from "../../providers/application-api/application-api";
import { DataProvider } from "../../providers/data/data";
import { SupportPage } from "../support/support";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import { BannersProvider } from "../../providers/banners/banners";

@Component({
  selector: "page-login",
  templateUrl: "login.html",
})
export class LoginPage {
  copyrightText: string;
  visibilities = new Map<number, boolean>();

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private appApi: ApplicationApiProvider,
    private loading: LoadingController,
    private dataProvider: DataProvider,
    private platform: Platform,
    private alertCtrl: AlertController,
    private starms: StarmsClientProvider,
    private banners: BannersProvider
  ) {}

  ionViewDidEnter(): void {
    // Present marketplace info panel
    this.appApi.presentMarketPlaceInfo();
    this.loading.create().dismissAll();

    // Clear session data
    if (!this.appApi.isDev()) {
      localStorage.clear();
      this.dataProvider.clearData();
    }
  }

  ionViewDidLoad(): void {
    this.loading.create().dismissAll();

    // Clear session data
    if (!this.appApi.isDev()) {
      localStorage.clear();
      this.dataProvider.clearData();
    }

    this.banners.loginMessages.subscribe((messages) => {
      for (let message of messages) {
        this.banners.displayBannerMessage(message);
      }
    });

    this.copyrightText = this.appApi.getCopyrightText();
  }

  async presentAlert(element: any) {
    let alert = this.alertCtrl.create({
      title: element.title,
      message: element.message,
      buttons: [
        {
          text: "Do not show again",
          role: "cancel",
          handler: () => {
            this.visibilities[element.id] = false;
            localStorage.setItem(
              "visibilities",
              JSON.stringify(this.visibilities)
            );
          },
        },
        {
          text: "Dismiss",
          role: "dismiss",
          handler: () => {},
        },
      ],
    });
    await alert.present();
  }

  logIn(): void {
    // if (!this.appApi.isDev()) {
    //   localStorage.clear();
    //   this.dataProvider.clearData();
    // }
    this.navCtrl.push("app");
    // this.appApi.createAuthBrowser(() => {});
  }

  logInDemo() {
    this.navCtrl.push("demo");
  }

  support() {
    this.navCtrl.push(SupportPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts